import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

interface BusinessUnitPieChartProps {
  data: {
    [key: string]: number;
  };
}

const COLORS = {
  'LC': '#dc2626',
  'LE': '#eab308',
  'SC': '#2563eb',
  'GLL': '#10b981'
};

const BusinessUnitPieChart: React.FC<BusinessUnitPieChartProps> = ({ data }) => {
  const chartData = Object.entries(data).map(([name, value]) => ({
    name,
    value,
    color: COLORS[name as keyof typeof COLORS] || '#6b7280'
  }));

  return (
    <div className="chart-container">
      <h3 className="chart-title">Active Cases</h3>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
      <div className="legend-custom">
        {chartData.map((entry, index) => (
          <div key={index} className="legend-item">
            <div 
              className="legend-color" 
              style={{ backgroundColor: entry.color }}
            ></div>
            <span className="legend-label">{entry.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BusinessUnitPieChart;